import mediumZoom from "medium-zoom";

import "./auth";
import "./header";
import "./trustpilot";
import "./sb";
import "./ref_id";
import "./oneTrustConsentTracking";

mediumZoom(".slb", {
  background: "rgba(127,127,127,.8)"
});
